export default "/assets/images/big-sneeze-hero.png?54f94f7a1bbf32cfdfd2655344c3755b";